import { Link } from "react-router-dom";

const ValouseVoyageImmersion = () => {
  return (
    <div className="min-h-screen bg-[#3F2A24] text-[#F3E5CF]">
      <div className="max-w-3xl mx-auto px-6 py-16 space-y-10">
        {/* Back to Valouse */}
        <div className="mb-6">
          <Link
            to="/valouse"
            className="inline-flex items-center gap-2 text-sm text-[#E8D2B5] hover:text-[#F3E5CF] transition-colors"
          >
            <span>← Retour à COCON Valouse</span>
          </Link>
        </div>

        <header className="text-center space-y-3">
          <p className="text-xs tracking-[0.35em] uppercase text-[#E8D2B5]">COCON — Le Voyage Immobile</p>
          <h1 className="font-serif text-3xl md:text-4xl">Un voyage de la tête… au cœur</h1>
        </header>

        <section className="space-y-8 text-sm leading-relaxed">
          <article className="px-6 py-8 rounded-3xl bg-[#6B4A3B]/95 border border-[#E8D2B5]/40 text-center space-y-4">
            <p className="text-xs tracking-[0.35em] uppercase text-[#E8D2B5]">
              LE VOYAGE LE PLUS LONG FAIT QUARANTE CENTIMÈTRES
            </p>
            <p>
              Le voyage le plus long fait quarante centimètres.
              <br />
              Celui qui mène de la tête au cœur.
              <br />
              Quitter le mental qui analyse et contrôle,
              <br />
              pour revenir à ce qui ressent, sait et respire.
            </p>
            <p className="text-sm tracking-[0.35em] uppercase text-[#E8D2B5]">⸻</p>
            <p>
              Il y a des moments où quelque chose ne sonne plus juste.
              <br />
              Pas à l’extérieur.
              <br />
              À l’intérieur.
            </p>
            <p>
              Une fatigue diffuse.
              <br />
              Une vie qui continue.
              <br />
              Et toi, comme suspendu·e au milieu.
            </p>
            <p>
              Tu avances.
              <br />
              Tu tiens.
              <br />
              Tu fais ce qu’il faut faire.
            </p>
            <p>
              Mais quelque chose s’est éloigné.
              <br />
              Tu ne sais plus très bien quand.
              <br />
              Peut-être lentement.
              <br />
              Peut-être en t’adaptant trop.
            </p>
            <p>
              À force de dire « ça va »
              <br />
              quand, au fond, tu aurais eu besoin de t’arrêter.
            </p>
            <p>
              Tu as cherché.
              <br />
              Des lectures.
              <br />
              Des pratiques.
              <br />
              Des espaces de mieux-être.
            </p>
            <p>
              Tu as compris beaucoup de choses.
              <br />
              Mais rien ne s’est vraiment déplacé.
            </p>
            <p>
              Parce que le retour à soi
              <br />
              n’est ni une méthode
              <br />
              ni une liste d’étapes à réussir.
            </p>
            <p>
              C’est un passage.
              <br />
              Un glissement de la tête vers le cœur.
              <br />
              Un chemin court en distance,
              <br />
              mais profond en vérité.
            </p>
            <p>
              Et ce chemin-là
              <br />
              ne se traverse pas seul·e.
            </p>
          </article>

          <article className="px-6 py-8 card-sacred text-center text-[#3F2A24] space-y-4">
            <p className="text-xs tracking-[0.35em] uppercase text-[#3F2A24]">
              PEU IMPORTE COMMENT TU ARRIVES
            </p>
            <p>
              Intrigué·e.
              <br />
              Fatigué·e.
              <br />
              Sur la réserve.
              <br />
              À bout de souffle.
            </p>
            <p>
              Tu n’as pas besoin d’être prêt·e.
              <br />
              Ni clair·e.
              <br />
              Ni fort·e.
            </p>
            <p>
              Tu as seulement besoin
              <br />
              d’écouter cette part en toi
              <br />
              qui murmure : VIENS!
            </p>
          </article>

          <article className="px-6 py-8 rounded-3xl bg-[#E8D2B5]/95 border border-[#EAD3AE]/60 text-center text-[#3F2A24] space-y-4">
            <p className="text-xs tracking-[0.35em] uppercase">
              POURQUOI TU AS L’IMPRESSION DE TOURNER EN ROND
            </p>
            <p>
              Tu n’es pas brisé·e.
              <br />
              Tu es simplement coupé·e.
            </p>
            <p>
              Pendant longtemps,
              <br />
              tu as appris à analyser,
              <br />
              comprendre,
              <br />
              anticiper,
              <br />
              tenir.
            </p>
            <p>
              Ton mental a pris la place.
              <br />
              Il t’a protégé·e.
              <br />
              Et, sans le vouloir,
              <br />
              il t’a éloigné·e du ressenti.
            </p>
            <p>
              Alors tu vis au-dessus de toi-même.
              <br />
              Déconnecté·e du corps.
              <br />
              De l’intuition.
              <br />
              De ce qui sait sans expliquer.
            </p>
            <p>
              Tu as essayé d’autres chemins :
              <br />
              • comprendre sans traverser
              <br />
              • écouter sans ressentir
              <br />
              • parler sans intégrer
            </p>
            <p>
              Et quelque chose en toi sait
              <br />
              que ce n’est pas suffisant.
            </p>
            <p>
              <span className="italic uppercase">COCON</span> est un cercle de passage.
              <br />
              Un lieu pour déposer,
              <br />
              se retrouver,
              <br />
              et laisser émerger ce qui demande à vivre.
            </p>
          </article>
        </section>
      </div>
    </div>
  );
};

export default ValouseVoyageImmersion;
